/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Token } from '@/data/types/Token';
import { normalizeStoreTokenPath } from '@/data/utils/normalizeStoreTokenPath';
import { ParsedUrlQuery } from 'querystring';

const DEFAULT_SLUG = 'home';
const DEFAULT_SLUG_ES = 'home-es';

/**
 * Context path parse support for backward compatibility of ReactJs(Emerald) implementation.
 * @param path
 * @param contextPath
 * @returns
 */
export const getIdFromPath = (path: ParsedUrlQuery['path'], storeToken: Token = {}) => {
	if (!path) {
		return DEFAULT_SLUG_ES;
	}

	const identifier =
		[normalizeStoreTokenPath({ path, storeUrlKeyword: storeToken.urlKeywordName })]
			.flat()
			.filter(Boolean)
			.join('/') || DEFAULT_SLUG;

	const slugs = identifier?.split('/');

	return slugs.length > 1 ? slugs?.at(-1) ?? identifier : identifier;
};
